import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Divider, Card } from 'antd'
import { CloseCircleOutlined, DeleteFilled } from '@ant-design/icons'
import RegimenCard from './regimen.card'
import _ from 'lodash'
import '../../css/patient.scss'
import { assignRegimens } from '../../store/action/regimen.action'
import serviceInterface from '../../services/service.interface'
import { useLocation } from 'react-router'
import moment from 'moment'

const AssignedRegimens = (props) => {
  const location = useLocation()
  const [regimen, setRegimen] = useState(null)
  const patient = location.state.patient

  useEffect(() => {
    props.regimens &&
      props.regimens.length > 0 &&
      handleRowSelect(props.regimens[0])
  }, [props.regimens])

  var handleRowSelect = (reg) => setRegimen(reg)

  var handleRemoveClick = (e, id) => {
    e.stopPropagation()
    var regs = serviceInterface
      .RegimenServide()
      .removeRegimen(id, props.regimens)
    props.assignRegimen(regs)
  }

  var renderRegimens = () => {
    var regimens = props.regimens ? props.regimens : []
    return regimens.map((reg, i) => {
      var selected = reg._id == regimen?._id
      return (
        <Row
          className={selected ? 'regimenRow regimenRow-selected' : 'regimenRow'}
          onClick={() => handleRowSelect(reg)}
        >
          <Col style={{ width: '100%' }}>
            <Row>
              <Col>
                <Row className='regHeader'>{reg.name}</Row>
                <Row className='descp'></Row>
              </Col>
              <Col className='removeIcon'>
                <DeleteFilled onClick={(e) => handleRemoveClick(e, reg._id)} />
              </Col>
            </Row>
          </Col>
        </Row>
      )
    })
  }

  return (
    <Col id={'selectedregimenview'} className='assignedContainer'>
      <Row className='selectorContainer'>
        <Col style={{ width: '100%' }}>
          <Row className='header'>
            <Col style={{ width: '100%' }}>
              <Row>ASSIGNED REGIMENS</Row>
              <Row className='descp'>
                <Col>SURGERY DATE</Col>
                <Col style={{ marginLeft: 'auto' }}>
                  {moment(patient?.surgery?.date).format('MM/DD/YYYY')}
                </Col>
              </Row>
            </Col>
          </Row>
          <Card bordered={false} className='assignedCard'>
            {renderRegimens()}
          </Card>
        </Col>
      </Row>
      <Row>
        <Col className='assignBody' style={{ width: '100%' }}>
          {props.regimens && props.regimens.length > 0 && (
            <RegimenCard regimen={regimen} hideBtn hideHeader />
          )}
        </Col>
      </Row>
    </Col>
  )
}

AssignedRegimens.propTypes = {
  company: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    company: state.profile.company,
    regimens: state.regimen.assignedRegs,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    assignRegimen: (regimens) => dispatch(assignRegimens({ regimens })),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignedRegimens)
